import type React from 'react';

import BlurCircle from '../BlurCircle/BlurCircle';
import styles from './BackgroundBlurCircles.module.scss';

const BackgroundBlurCircles: React.FC = () => {
  return (
    <div className={styles.blurCircleContainer}>
      <BlurCircle className={styles.topLeft} />
      <BlurCircle className={styles.bottomRight} />
    </div>
  );
};

export default BackgroundBlurCircles;
